module.exports = __webpack_public_path__ + "img/icon-map-implantation-06.74437cdc.svg";